<template>
  <div class="job-info">
    <div v-if="isHotJob" class="hot-job-icon">
      <i class="fire-icon iconfont iconFire"></i>
    </div>
    <div v-auto-tooltip class="job-name">
      <span class="name">
        <a class="job-detail-link" :href="getJobDetailUrl()" @click.stop="">{{ jobName }}</a>
      </span>
      <div v-if="referralSettings.to_show_referral" class="referral-btn">
        <el-popover trigger="hover" placement="right" popper-class="referral-info-popper">
          <template #reference>
            <i class="iconfont iconhongbao1"></i>
          </template>
          <div v-if="referralSettings.steps_setting">
            <ReferralSettings
              class="referral-settings-content"
              :refStepsSetting="referralSettings.steps_setting"
              :company="company"
              :hasCustomReferralWord="hasCustomReferralWord"
              :isHiddenRewards="isHiddenRewards"
              :isUsePointReplacePayroll="isUsePointReplacePayroll"
              :isFosunCompany="isFosunCompany"
              :isCompanyEmployee="isCompanyEmployee"
              :isADPCompany="isADPCompany"
              :isCoachCompany="isCoachCompany"
              :customizationRewardsRules="customizationRewardsRules"
            ></ReferralSettings>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="job-detail-info">
      <div v-auto-tooltip v-if="roleType" class="info-item role-type">{{ roleType }}</div>
      <div v-auto-tooltip class="info-item open-date">{{ formatDate(openDate) }}</div>
      <div v-auto-tooltip v-if="isOnlyOneLocation && firstLocation" class="info-item location" :class="[!canOpenLocation(locationList[0]) && 'is-disabled']" @click.stop="handleOpenLocationMap(locationList[0])">{{ firstLocation }}</div>
    </div>
    <el-popover v-if="!isOnlyOneLocation && locationList?.length" v-model="showLocationList" class="more-location-wrapper" trigger="hover" @click.native.stop>
      <template #reference>
        <span class="more-location">
          <span v-auto-tooltip class="location-count">{{ $t('company.label.jobLocationCount', { count: locationCount })  }}</span>
          <i class="expand-icon el-icon-arrow-down" :class="showLocationList && 'is-expand'"></i>
        </span>
      </template>
      <div class="location-list">
        <div
          v-auto-tooltip
          v-for="(location, index) in locationList"
          class="location"
          :class="[!canOpenLocation(location) && 'is-disabled']"
          :key="index"
          @click="handleOpenLocationMap(location)"
        >{{ location.city ? location.city.i18nName : '' }}{{ location.address && ('-' + location.address) }}</div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import ReferralSettings from '@/views/company/pc/components/referralSettings.vue'
import { addQueryInPath } from '@/utils/common'

export default {
  components: {
    ReferralSettings
  },
  props: {
    jobId: {
      required: true
    },
    jobName: {
      type: String,
      required: true
    },
    isHotJob: {
      type: Boolean,
      default: false
    },
    openDate: {
      type: String,
      required: true
    },
    roleType: {
      type: String
    },
    locationList: {
      type: Array,
      default: null
    },
    company: {
      type: Object,
      required: true
    },
    hasCustomReferralWord: {
      type: Boolean,
      default: false
    },
    isHiddenRewards: {
      type: Boolean,
      default: false
    },
    isUsePointReplacePayroll: {
      type: Boolean,
      default: false
    },
    isADPCompany: {
      type: Boolean,
      default: false
    },
    isCoachCompany: {
      type: Boolean,
      default: false
    },
    isFosunCompany: {
      type: Boolean,
      default: false
    },
    isOverseasCompany: {
      type: Boolean,
      default: false
    },
    isCompanyEmployee: {
      type: Boolean,
      default: false
    },
    customizationRewardsRules: {
      type: Object,
      required: false,
      default: () => {}
    },
    referralSettings: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showLocationList: false
    }
  },
  computed: {
    locationCount () {
      return this.locationList?.length || 0
    },
    isOnlyOneLocation () {
      return this.locationCount === 1
    },
    firstLocation () {
      return this.locationList && this.locationList[0]?.city.i18nName
    }
  },
  created () {

  },
  methods: {
    formatDate (date) {
      return date ? moment(date).format('YYYY-MM-DD') : '-'
    },
    loadUrlQuery () {
      const hashStr = decodeURIComponent(this.$route.hash)
      const query = {}
      _.chain(hashStr.substring(1)).split('&').map(item => item.split('=')).forEach((paramArr) => {
        const paramName = paramArr[0]
        let paramVal = null
        if (paramArr.length > 1) {
          paramVal = paramArr[1]
        }
        query[paramName] = paramVal
      }).value()
      return query
    },
    getJobDetailUrl () {
      const query = this.loadUrlQuery()
      const hashStr = _.chain(query).map((val, key) => {
        if (val === null || val === undefined) {
          val = ''
          if (key === 'ji' || key === 'jt') {
            val = 0
          }
        }
        return `${key}=${encodeURIComponent(val)}`
      }).join('&').value()
      let path = `/recruiting/company/${this.company.id}/job/${this.jobId}/job-detail`
      const params = {
        aj_source: this.$route.query.aj_source,
        aj_code: this.$route.query.aj_code
      }
      const pathReg = /^\/msdchina\/professionals.*/
      if (pathReg.test(this.$route.path)) {
        params.backUrl = this.$route.path
      }
      path = addQueryInPath(path, params, true)
      return `${path}#${hashStr}`
    },
    canOpenLocation (location) {
      if (!location) {
        return false
      }
      const lng = parseFloat(location.lng)
      const lat = parseFloat(location.lat)
      if (!lng || !lat) {
        return false
      }
      return true
    },
    handleOpenLocationMap (location) {
      if (this.isOverseasCompany || !this.canOpenLocation(location)) {
        return
      }
      this.$emit('openLocationMap', location)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-info {
  padding: 40px 22px 36px;
  border-bottom: 1px solid #dcdfe6;
  position: relative;

  .hot-job-icon {
    position: absolute;
    left: 0;

    .fire-icon {
      font-size: 16px;
      line-height: 26px;
      color: var(--custom-color);
      vertical-align: middle;
    }
  }

  .job-name {
    color: var(--custom-color);
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;

    .name {
      vertical-align: middle;
      color: var(--custom-color);
      .job-detail-link {
        color: var(--custom-color);
      }
    }

    .referral-btn {
      display: inline-block;
      vertical-align: sub;
      margin-left: 10px;
      .iconfont {
        font-size: 28px;
        color: var(--custom-color);
      }
    }
  }

  .job-detail-info {
    display: flex;
    margin-top: 16px;
    color: #606266;

    .info-item {
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 1px;
        background: #dedfe6;
        position: absolute;
        top: 5px;
        bottom: 5px;
        left: 0;
      }

      &:first-child::before {
        display: none;
      }

      + .info-item {
        margin-left: 20px;
        padding-left: 20px;
      }

    }
    .location {
      cursor: pointer;
    }

    .is-disabled {
      cursor: text;
    }
  }

  .more-location-wrapper {
    display: block;
    margin-top: 10px;

    ::v-deep .el-popover__reference-wrapper {
      display: inline-block;
      max-width: 100%;
    }

    .more-location {
      display: inline-flex;
      max-width: 100%;
      cursor: pointer;
      overflow: hidden;

      .location-count {
        color: var(--custom-color);
      }

      .expand-icon {
        margin-left: 10px;
        transition: transform .3s ease;
        line-height: inherit;

        &.is-expand {
          transform: rotateZ(180deg);
        }
      }
    }

  }
}

.location-list {
  max-width: 300px;
  max-height: 200px;
  padding: 4px 8px;
  overflow: hidden auto;

  .location {
    color: #606266;
    cursor: pointer;

    + .location {
      margin-top: 14px;
    }
  }

  .is-disabled {
    cursor: not-allowed;
  }
}
</style>

<style lang="scss">
.referral-info-popper {
  border: 1px solid var(--custom-color) !important;
  .popper__arrow {
    border-right-color: var(--custom-color) !important;
  }
  p {
    margin: 0;
    padding: 0;
  }
  .referral-settings-content {
    .rewards-container {
      color: #444444;
      font-size: 12px;
      .rewards-title {
        color: #444444;
        font-size: 15px;
        white-space: nowrap;
      }
      .job-referral-info-list {
        list-style: none;
        .referral-item {
          margin: 5px;
          &:last-child {
            margin-bottom: 0;
          }
          .referral-info {
            vertical-align: middle;
            display: inline-block;
            .referral-title {
              font-size: 15px;
            }
            .referral-tip {
              font-size: 13px;
              margin-left: 10px;
            }
          }
          &::before {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #444444;
            display: inline-block;
            margin-right: 10px;
            vertical-align: middle;
            content: "";
            margin-bottom: 0px;
          }
        }
        .has-more {
          &::before {
            margin-bottom: 18px;
          }
        }
      }
    }
  }
}
</style>
